import React from "react";
import AuditContent from "./audit-content.jsx";

const ReportContent = ({data}) => {
    return (
        <div>
            {data.map((element, index) => (
                <AuditContent element={element} key={index}/>
            ))}
        </div>
    );
};

export default ReportContent;